import axios from 'axios';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Spinner from '../spinner/Spinner';

export default function Services () {
    const [services, setServices] = useState([]);;
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        const loadServices = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`${process.env.REACT_APP_API_PATH}services/public`,{
                    params: {
                        page: 1,
                        size: 1000,
                        order: 'DESC'
                    }
                });
                setLoading(false);
                if (res.status !== +process.env.REACT_APP_RECORD_NOT_FOUND) {
                    const { error, data } = res.data;
                    if (!error && Array.isArray(data)) setServices(data);
                }
            } catch (err) {
                setLoading(false);
                console.error(err);
            }
        };
        loadServices();        
    },[]);

    if(services.length < 1){
        return '';
    }

    return <>
      <div className="container-xxl py-5">
          <div className="container">
              <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
                  <h1 className="mb-3">Available Services</h1>
                   <p>Our Services includes the following</p>
              </div>
              <div className="row g-4 text-center">
                {
                    loading ? 
                    
                    <Spinner message='Loading Services' />                    
                :
                    services.map((service)=>{
                        return <div key={service.id} className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <Link to={`/services/${service.slug}`} className="cat-item d-block bg-light text-center rounded p-3">
                                <div className="rounded p-4">
                                    <div className="icon mb-3">
                                        <img className="img-fluid" src={service.rootImagePath+service.defaultImage} alt="Icon" />
                                    </div>
                                    <h6>{service.name}</h6>
                                    {
                                        service.value && <span>{service.value} Properties</span>
                                    }
                                </div>
                            </Link>
                        </div>
                    })
                }
              </div>
          </div>
      </div>
    </>
}